import { Button, Container, Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import paypal from "../../images/paypal.svg";
import google from "../../images/google.svg";
import dropbox from "../../images/dropbox.svg";
import bannerThumb from "../../images/banner-thumb.png";
import Header from "../Header/Header";

const HeroSection = () => {
  return (
    <div className="hero-section">
      {/* navbar  */}
      <Header />
      {/* HeroSection  */}
      <Container sx={{ py: 6 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 2, sm: 8, md: 12 }}
            sx={{
              alignItems: "center",
              flexDirection: { xs: "column-reverse", md: "row" },
            }}
          >
            <Grid item xs={2} sm={4} md={6}>
              <Box
                sx={{ color: "#fff", textAlign: { xs: "center", md: "left" } }}
              >
                <Typography
                  sx={{ fontSize: { xs: 30, md: 60 }, fontWeight: 700, mb: 3 }}
                  variant="h1"
                >
                  Experience your ultimate mobile application
                </Typography>
                <Typography variant="body1">
                  Get your blood tests delivered at let home collect sample from
                  the victory of the managments that supplies best design system
                  guidelines ever.
                </Typography>
              </Box>
              <Box>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={{ xs: 1, sm: 2, md: 4 }}
                  sx={{ mt: 3 }}
                >
                  <Button
                    sx={{ borderRadius: 50 }}
                    color="info"
                    variant="contained"
                  >
                    Get Started
                  </Button>
                  <Button
                    sx={{ color: "#fff" }}
                    variant=""
                    startIcon={<PlayCircleIcon />}
                  >
                    Watch Video
                  </Button>
                </Stack>
              </Box>
              {/* Sponsored  */}
              <Box
                sx={{
                  my: 4,
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.6)",
                  }}
                  variant="subtitle1"
                >
                  Sponsored by:
                </Typography>
                <img src={paypal} alt="" />
                <img src={google} alt="" />
                <img src={dropbox} alt="" />
              </Box>
            </Grid>
            <Grid item xs={2} sm={4} md={6}>
              <Box>
                <img className="banner-thumb" src={bannerThumb} alt="" />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default HeroSection;
